/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SignInResponseDto = {
  /**
   * The name of the challenge that you must pass
   */
  challengeName?: SignInResponseDto.challengeName;
  /**
   * The session that should be passed both ways in challenge-response calls to the service.
   */
  session?: string;
};
export namespace SignInResponseDto {
  /**
   * The name of the challenge that you must pass
   */
  export enum challengeName {
    SMS_MFA = 'SMS_MFA',
    EMAIL_OTP = 'EMAIL_OTP',
    SOFTWARE_TOKEN_MFA = 'SOFTWARE_TOKEN_MFA',
    SELECT_MFA_TYPE = 'SELECT_MFA_TYPE',
    MFA_SETUP = 'MFA_SETUP',
    PASSWORD_VERIFIER = 'PASSWORD_VERIFIER',
    CUSTOM_CHALLENGE = 'CUSTOM_CHALLENGE',
    SELECT_CHALLENGE = 'SELECT_CHALLENGE',
    DEVICE_SRP_AUTH = 'DEVICE_SRP_AUTH',
    DEVICE_PASSWORD_VERIFIER = 'DEVICE_PASSWORD_VERIFIER',
    ADMIN_NO_SRP_AUTH = 'ADMIN_NO_SRP_AUTH',
    NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED',
    SMS_OTP = 'SMS_OTP',
    PASSWORD = 'PASSWORD',
    WEB_AUTHN = 'WEB_AUTHN',
    PASSWORD_SRP = 'PASSWORD_SRP',
    NULL = 'null',
  }
}

